import React from "react";
import ReactDOM from "react-dom/client";
import AdminPage from "./adminpage";
import "./admin.css";

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);

  const currentPath = window.location.pathname.toLowerCase().replace(/\/$/, "");

  if (currentPath === "/admin") {
    root.render(
      <React.StrictMode>
        <AdminPage />
      </React.StrictMode>
    );
  } else {
    root.render(null);
  }
}